import { asSection } from 'transformers/sections';
import Template from 'types/Template';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const asTemplate = (o: Exclude<any, undefined | null>): Template => {
  return {
    id: o._id,
    name: o.name,
    reference_label: o.reference_label || '',
    type: o.type,
    user_revision: o.user_revision,
    exam_sections: (o.exam_sections || []).map(asSection),
  };
};

export { asTemplate };
